import React from "react";
import "./ratebar.css";


const RevenueMetric = ({
    icon,
    label,
    value,
    negative = false,
    total = false
}) => (
    <div className={`rate-bar-metric ${total ? "rate-bar-total-metric" : ""}`}>
    
        <div className="rate-bar-metric-content">
            <div className="rate-bar-label">
                {label}
            </div>

            <div className={`rate-bar-value ${negative ? "rate-bar-negative" : ""}`}>
                {negative ? "- " : ""}₹ {value}
            </div>
        </div>
    </div>
);

const RevenueRateBar = React.memo(({ rateDetails, bookingDetails }) => {

    const parseWithPrecision = (num, decimals = 2) => {
        const value = parseFloat(num);

        if (isNaN(value)) {
            return 0;
        }

        return parseFloat(value.toFixed(decimals));
    };

    const greenFee = parseWithPrecision(
        rateDetails?.totalGreenFee
    );

    const cartFee = parseWithPrecision(
        rateDetails?.totalCartFee
    );

    const caddyFee = parseWithPrecision(
        rateDetails?.totalCaddyFee
    );

    const discount = parseWithPrecision(
        rateDetails?.totalDiscount
    );

    const totalAmount = parseWithPrecision(
        rateDetails?.totalAmount
    );

    return (
        <div className="rate-bar revenue-rate-bar">

            <div className="rate-bar-inner">

                {/* =========================
                    Primary Green Fee
                ========================= */}

                <div className="rate-bar-green-fee">
                
                    <div>
                        <div className="rate-bar-primary-label">
                            Total Green Fee
                        </div>

                        <div className="rate-bar-primary-value">
                            ₹ {greenFee}
                        </div>
                    </div>

                </div>

                {/* =========================
                    Revenue Metrics
                ========================= */}

                <div className="rate-bar-metrics">

                    <RevenueMetric
                        icon="cart"
                        label="Total Cart Fee"
                        value={cartFee}
                    />

                    <RevenueMetric
                        icon="caddy"
                        label="Total Caddy Fee"
                        value={caddyFee}
                    />

                    <RevenueMetric
                        icon="discount"
                        label="Discount Amount"
                        value={discount}
                        negative={true}
                    />

                    <RevenueMetric
                        icon="amount"
                        label="Total Amount"
                        value={totalAmount}
                        total={true}
                    />

                </div>

                {/* =========================
                    Date + Bookings
                ========================= */}

                <div className="rate-bar-summary">

                    <div className="rate-bar-date">

                        <div className="rate-bar-date-content">

                            <span>
                                {bookingDetails?.fromDate || "-"}
                            </span>

                            <span className="mx-2"> To </span>

                            <span>
                                {bookingDetails?.toDate || "-"}
                            </span>

                        </div>

                    </div>

                    <div className="rate-bar-bookings">
                       
                        <div>

                            <div className="rate-bar-bookings-label">
                                {bookingDetails?.type || "Total Bookings"}
                            </div>

                            <div className="rate-bar-bookings-value">
                                {bookingDetails?.total || 0}
                            </div>

                        </div>

                    </div>

                </div>

            </div>

        </div>
    );
});

export default RevenueRateBar;